export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.greetings-list', {
      url: 'greetings',
      template: '<nets-greetings-list></nets-greetings-list>',
    });
};
